import '../style/cardStyle.css';
import { useSelector } from 'react-redux';
import CardCom from '../components/Card';
import { Typography } from '@mui/material';
import Progress from '../components/prograssBar';
import { Helmet } from 'react-helmet-async';

export default function AthkarEsalah() {
  const value = useSelector((state) => state.athkarEsalah.value); 
  const card = useSelector((state) => state.athkarEsalah.data); // Ensure this is the correct slice of state

  return (
    <>
    <Helmet>
        <title>أذكار الصلاة</title>
        <meta name='description' content='اذكار الصلاه' />
        <link rel="canonical" href="/athkarEsalah" />
    </Helmet>
    <div className='mainScreen'>
      <Progress value={value}/>
       <Typography variant="h3" component="p" className='title' sx={{ color: "text.primary"}}>أذكار الصلاة</Typography>
      <CardCom card={card} type={'salah'}/>
    </div>

    </>
  );
}
